/* Ostirè cart drawer add-ons.

   Handles the "Add" buttons on the suggested pieces inside the cart drawer.
   The drawer content is re-rendered whenever the cart changes, so the
   listener is delegated from the document rather than bound to each form.

   Loaded as a module so it can import the theme's own CartAddEvent; the
   drawer, the cart bubble and the header all listen for that event and
   re-render from the section HTML it carries.

   With JS off, or if anything fails, the form posts to /cart/add as normal. */

import { CartAddEvent } from '@theme/events';

function sectionIds() {
  const ids = [];
  const add = function (el) {
    const sec = el && el.closest('[id^="shopify-section-"]');
    const id = sec ? sec.id.replace('shopify-section-', '') : null;
    if (id && ids.indexOf(id) === -1) ids.push(id);
  };
  add(document.querySelector('cart-drawer-component'));
  add(document.querySelector('#header-component'));
  add(document.querySelector('cart-icon-component'));
  return ids;
}

document.addEventListener('submit', function (e) {
  const form = e.target instanceof HTMLFormElement && e.target.matches('[data-os-cart-add]') ? e.target : null;
  if (!form || !window.fetch) return;

  const drawer = document.querySelector('cart-drawer-component');
  if (!drawer) return;

  e.preventDefault();

  const btn = form.querySelector('button[type="submit"]');
  if (btn) btn.disabled = true;

  // `Theme` is declared with const in a classic script, so it is reachable by
  // name but is not a property of window.
  const themeRoutes = (typeof Theme !== 'undefined' && Theme.routes) || null;
  const routes = themeRoutes || { cart_add_url: '/cart/add.js', cart_url: '/cart' };

  const body = new FormData(form);
  const variantId = body.get('id');
  const ids = sectionIds();
  if (ids.length) body.append('sections', ids.join(','));

  fetch(routes.cart_add_url, { method: 'POST', headers: { Accept: 'application/json' }, body: body })
    .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
    .then(function (res) {
      if (!res.ok) throw new Error(res.json.description || 'add failed');
      const sections = res.json.sections || null;
      return fetch(routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.dispatchEvent(new CartAddEvent(cart, 'ostire-cart-upsell', {
            source: 'ostire-cart-upsell',
            itemCount: cart.item_count,
            variantId: variantId,
            sections: sections
          }));
        });
    })
    .catch(function () {
      form.submit();
    })
    .finally(function () {
      if (btn && btn.isConnected) btn.disabled = false;
    });
});

/* Arrows on the suggested-pieces row. Delegated for the same reason as the
   add buttons: the row is replaced whenever the cart changes. */

function syncRailArrows(rail) {
  const box = rail.closest('.os-cart-upsell');
  if (!box) return;
  const prev = box.querySelector('[data-os-rail="prev"]');
  const next = box.querySelector('[data-os-rail="next"]');
  if (prev) prev.disabled = rail.scrollLeft <= 2;
  if (next) next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
}

document.addEventListener('click', function (e) {
  const btn = e.target instanceof Element ? e.target.closest('[data-os-rail]') : null;
  if (!btn) return;
  const box = btn.closest('.os-cart-upsell');
  const rail = box && box.querySelector('.os-cart-upsell__rail');
  if (!rail) return;
  const card = rail.querySelector('.os-cart-upsell__card');
  const step = card ? card.getBoundingClientRect().width + 10 : rail.clientWidth * 0.8;
  const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  rail.scrollBy({ left: btn.dataset.osRail === 'prev' ? -step : step, behavior: reduce ? 'auto' : 'smooth' });
});

// Scroll events do not bubble, so listen in the capture phase.
document.addEventListener('scroll', function (e) {
  const rail = e.target instanceof Element && e.target.matches('.os-cart-upsell__rail') ? e.target : null;
  if (rail) syncRailArrows(rail);
}, true);
